import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import classnames from 'classnames';
import { s as styles, F as FormHelperRenderer } from './FormHelperRenderer-Z-tj85JY.js';
import { useFormHelperState, FormHelperStateProvider } from './useFormHelperState.js';
import './useFormHelperAnimation.js';
import 'react';
import '@hh.ru/magritte-common-func-utils';
import '@hh.ru/magritte-common-resize';
import '@hh.ru/magritte-ui-typography';
import '@hh.ru/magritte-common-dom-storage';

const FieldsGroupHelper = ({ children, description, errorMessage, invalid, disabled, descriptionId, topSpacing = 8, 'data-qa': dataQa = 'fields-group-helper-container', inline = false, }) => {
    const formHelperState = useFormHelperState({
        description,
        errorMessage,
        invalid,
        disabled,
    });
    return (jsxs("div", { "data-qa": dataQa, className: classnames({ [styles.fieldsGroupHelperInline]: inline }), children: [jsx(FormHelperStateProvider, { ...formHelperState, children: children }), jsx(FormHelperRenderer, { ...formHelperState, disabled: disabled, descriptionId: descriptionId, topSpacing: topSpacing, errorMessage: errorMessage, description: description })] }));
};

export { FieldsGroupHelper };
//# sourceMappingURL=FieldsGroupHelper.js.map
